import { withTimeout } from 'shared/utils/withTimeout';
import { getServiceWorkerContainer } from '../serviceWorkerContainer';

export interface ServiceWorkerRegistrationState {
  hasController: boolean;
  active: ServiceWorkerState | null;
  waiting: ServiceWorkerState | null;
  installing: ServiceWorkerState | null;
}

/** The registration is read to explain a failure: it must not hold up what follows it (a repair, a reload). */
const REGISTRATION_READ_TIMEOUT_MS = 2_000;

/**
 * Which worker controls the page and which ones are installing or waiting.
 * `null`: no service worker API, or the registration was not read in time.
 */
export async function getServiceWorkerRegistrationState(
  timeoutMs = REGISTRATION_READ_TIMEOUT_MS
): Promise<ServiceWorkerRegistrationState | null> {
  const container = getServiceWorkerContainer();
  if (!container) {
    return null;
  }
  const registration = await withTimeout(container.getRegistration(), timeoutMs, () => null);
  if (registration === null) {
    return null;
  }
  return {
    hasController: container.controller !== null,
    active: registration?.active?.state ?? null,
    waiting: registration?.waiting?.state ?? null,
    installing: registration?.installing?.state ?? null,
  };
}
